import {UsePermissions} from "../../hooks/usePermissions";
import React, {useState} from "react";
import {Navigate} from "react-router";
import {TablaPensionado} from "./components/TablaPensionado";
import {ModalNuevoPensionado} from "./components/ModalNuevoPensionado";
import {ModalEditarPensionado} from "./components/ModalEditarPensionado";

export const PensionadoPage = () => {
    const [permisos] = UsePermissions();
    const [displayNewModal, setDisplayNewModal] = useState(false);
    const [displayeditModal, setDisplayeditModal] = useState(false);
    const [fieldEdit, setFieldEdit] = useState({});
    const [reload, setReload] = useState(false);

    const editarUsuario= (e) => {
        setFieldEdit({...e});
        setDisplayeditModal(true);
    }

    const crearnuevoUsuario = () => {
        setDisplayNewModal(true);
    }

    const onHide = () => {
        setDisplayNewModal(false);
        setReload(true);
        resetLoad();
    }
    const onHideEdit = () => {
        setDisplayeditModal(false);
        setReload(true);
        resetLoad()
    }

    const resetLoad = () => {
        setTimeout(() =>{
            setReload(false);
        }, 2000)
    }

    return(
        <div className="container-relative">
            {permisos.consultar
                ?
                <TablaPensionado reload={resetLoad} obtenerParametrosUser={editarUsuario} nuevoUsuario={crearnuevoUsuario}/>
                :
                <Navigate to="/home"/>
            }
            <ModalNuevoPensionado show={displayNewModal} hide={onHide}/>
            <ModalEditarPensionado show={displayeditModal} hide={onHideEdit} fields={fieldEdit}/>
        </div>
    )
}
